<!--<small style="position: fixed" class="debug">{{me}}</small>-->
<div style="height: 100%;">
    @switch (type) {
        @case (0) {
            <div>
                <div class="cardBottom">
                    {{ 'general.remoteScreens' | transloco }}
                </div>
                <div fxFlex fxLayoutAlign="start" class="card switch0">
                    <ul>
                        <li>
                            <mat-icon class="screenStatus" style="color: green">add_circle</mat-icon>
                            <mat-label>{{ 'general.connected' | transloco }}: {{ val1.screenOn }}</mat-label>
                        </li>
                        <li>
                            <mat-icon class="screenStatus" style="color: purple">filter_tilt_shift</mat-icon>
                            <mat-label>{{ 'general.totalScreens' | transloco }}: {{ val1.totalScreens }}</mat-label>
                        </li>
                        <li>
                            <mat-icon class="screenStatus" style="color: yellow">add_circle_outline</mat-icon>
                            <mat-label>{{ 'general.polling' | transloco }}: {{ val1.screenPoll }}</mat-label>
                        </li>
                        <li>
                            <mat-icon class="screenStatus" style="color: red">block</mat-icon>
                            <mat-label>{{ 'general.disconnected' | transloco }}: {{ val1.screenOff }}</mat-label>
                        </li>
                    </ul>
                </div>
            </div>
        }
        @case (1) {
            <div>
                <div class="cardBottom">
                    {{ 'general.usage' | transloco }}
                </div>
                <div class="card switch1">
                    <ul>
                        <li>
                            <mat-icon class="screenStatus" style="color: green">done</mat-icon>
                            <mat-label>{{ 'general.usage' | transloco }}: ({{ val1.resourceTotal }})</mat-label>
                        </li>
                        <li>
                            <mat-icon class="screenStatus" style="color: green">done</mat-icon>
                            <mat-label>{{ 'general.totalScenes' | transloco }}: ({{ val1.scenesTotal }})</mat-label>
                        </li>
                        <li>
                            <mat-icon class="screenStatus" style="color: green">done</mat-icon>
                            <mat-label>{{ 'general.totalScreens' | transloco }}: ({{ val1.stationsTotal }})</mat-label>
                        </li>
                        <li>
                            <mat-icon class="screenStatus" style="color: green">done</mat-icon>
                            <mat-label>{{ 'general.totalUsers' | transloco }}: (1)</mat-label>
                        </li>
                    </ul>
                </div>
            </div>
        }
        @case (2) {
            <div>
                <div class="cardBottom">
                    {{ 'general.enterpriseEdition' | transloco }}
                </div>
                <div fxFlex fxLayoutAlign="center" class="card switch2">
                    <mat-label>{{ 'general.notActive' | transloco }}</mat-label>
                </div>
            </div>
        }
        @case (3) {
            <div style="height: 100%;">
                <div class="cardBottom" style="position: relative">
                    {{ 'navigation.fullAccess' | transloco }}
                    @if (isAccountUpgradable) {
                        <button (click)="upgrade()" routerLinkActive="active" style="position:absolute; right:0; top: -1px" mat-button color="warn">[{{ 'navigation.upgrade' | transloco }}]</button>
                    }
                </div>
                <div class="card switch3 upgIcon">
                    @if (isResellerStatusActive) {
                        <mat-icon style="color: green">sentiment_very_satisfied</mat-icon>
                    }
                    @if (!isResellerStatusActive) {
                        <mat-icon style="color: red">sentiment_very_dissatisfied</mat-icon>
                    }
                    <mat-label [style.color]="isResellerStatusActive ? 'green' : 'red'">{{ isResellerStatusActive ? ('general.accountActive' | transloco) : ('general.accountInactive' | transloco) }}</mat-label>
                </div>
            </div>
        }
        @case (4) {
            <div style="height: 100%;">
                <div class="cardBottom">
                    {{ 'general.credentials' | transloco }}
                </div>
                <div fxFlex fxLayoutAlign="start" class="card switch3" style="user-select: text">
                    <ul>
                        <li>- user: {{ val1.email }}</li>
                        <li>- master server: {{ val2.masterServer.split('.')[0] + '...' }}</li>
                        <li>- business server: {{ val1.webApiBaseUrl.split('.')[0] + '...' }}</li>
                        <li>- business id: {{ val1.businessId }} / enterprise: {{ val1?.resellerId }}</li>
                        <li>- socket: 80/443</li>
                    </ul>
                </div>
            </div>
        }
        @case (5) {
            <div style="height: 100%;">
                <div class="cardBottom">
                    {{ title }}
                </div>
                <div class="card">
                    <ng-content></ng-content>
                </div>
            </div>
        }
        @default {
            <div>
                <div class="cardBottom">
                    {{ valA }}
                </div>
                <div fxFlex fxLayoutAlign="start" class="card2">
                    <ul>
                        @for (val of valB; track val) {
                            <li>
                                <mat-label>{{ val }}</mat-label>
                            </li>
                        }
                    </ul>
                </div>
            </div>
        }
    }
</div>
